import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import API from '../api/axios';

function TermsAndConditionModal({ show, onHide, onAccept }) {
  const [termsContent, setTermsContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      fetchTermsAndConditions();
    }
  }, [show]);

  const fetchTermsAndConditions = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await API.get("/settings/");
      const termsAndCondition = res.data.find(
        (item) => item.key === "terms_and_condition"
      );
      if (termsAndCondition && termsAndCondition.value) {
        setTermsContent(termsAndCondition.value);
      } else {
        setError('Terms and conditions not found in settings');
      }
    } catch (err) {
      console.error("Error fetching terms and conditions:", err);
      setError('Failed to load terms and conditions. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptAndClose = () => {
    if (onAccept) {
      onAccept();
    }
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-terms-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-dark">
          Terms & Conditions
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="p-4"
        style={{
          maxHeight: "65vh",
          overflowY: "auto",
          background: "linear-gradient(135deg, #f9fafb, #f3f4f6)",
          borderRadius: "12px",
          boxShadow: "inset 0 0 10px rgba(0,0,0,0.05)",
        }}
      >
        {loading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="ms-3">Loading terms and conditions...</span>
          </div>
        ) : error ? (
          <div className="alert alert-danger d-flex align-items-center" role="alert">
            <i className="fas fa-exclamation-triangle me-2"></i>
            <div>
              <strong>Error:</strong> {error}
              <br />
              <button
                className="btn btn-sm btn-outline-danger mt-2"
                onClick={fetchTermsAndConditions}
              >
                Try Again
              </button>
            </div>
          </div>
        ) : (
          <div
            className="terms-content"
            dangerouslySetInnerHTML={{ __html: termsContent }}
            style={{
              lineHeight: "1.8",
              fontSize: "15.5px",
              color: "#222",
              fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            }}
          />
        )}
      </Modal.Body>

      <Modal.Footer
        className="d-flex justify-content-between border-0 pt-3"
        style={{ background: "transparent" }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary px-4 rounded-pill"
          onClick={onHide}
        >
          Cancel
        </button>

        {!loading && !error && (
          <button
            type="button"
            className="btn btn-primary px-4 rounded-pill shadow-sm"
            onClick={handleAcceptAndClose}
          >
            <i className="fas fa-check me-2"></i>
            Accept Terms
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default TermsAndConditionModal;
